import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import RewardKitClaimsDash from "../../components/RewardKitClaims";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

/**
 * Reward kit claims admin page. Sends the admin to the login route when their config has no
 * `rewardKitClaims` access, and otherwise renders the claims dashboard against the backend
 * of the environment the admin is signed in to. The dashboard mounts only after the access
 * check passes, so an admin without access triggers no claims API call.
 */
const RewardKitClaims = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  const hasRewardKitClaimsAccess = !!userConfig?.rewardKitClaims?.hasAccess;

  useEffect(() => {
    if (!hasRewardKitClaimsAccess) {
      navigate(LOGIN);
    }
  }, [hasRewardKitClaimsAccess, navigate]);

  if (!hasRewardKitClaimsAccess) {
    return null;
  }

  return (
    <>
      <Navbar />
      <RewardKitClaimsDash adminConfig={userConfig.rewardKitClaims} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default RewardKitClaims;
